import { editorPastePlain } from './pastePlain.js';
import { editorPasteHTML } from './pasteHTML.js';

function coreEditorPaste(event) {
  // cancel paste
  event.preventDefault();

  let text;

  // get clipboard data
  const plainText = (event.originalEvent || event).clipboardData.getData('text/plain');
  const html = (event.originalEvent || event).clipboardData.getData('text/html');

  // detect if it has html or not
  if (html.length) {
    text = editorPasteHTML(html);
  } else {
    text = editorPastePlain(plainText);
  }

  // insert text manually
  document.execCommand("insertHTML", true, text);
}

export { coreEditorPaste }